import * as React from 'react'
import { Row, Col } from 'react-bootstrap'
import Card from './Card'
import InstantArticleScript from '../articles/components/InstantArticles/InstantArticleScript'
import Header from '../../../common/header/Header'

import './adFormat.scss'

// These MUST be bitwise (1, 2, 4, 8 etc) to allow for easy combinations
export enum AdFormats {
	Content = 1,
	Product = 2,
	Instant = 4,
	Video = 8,
	TrueNative = 16,
}

interface AdFormatProps {
	adFormat: AdFormats
	setFormat: (format: AdFormats) => void
}

const AdFormat = ({ adFormat, setFormat }: AdFormatProps) => {
	// Feature flag check
	const urlParams = new URLSearchParams(window.location.search)
	const showTrueNative = urlParams.get('showtruenative') === '1'

	const setAdFormatNative = () => {
		setFormat(AdFormats.Content)
	}
	const setAdFormatProduct = () => {
		setFormat(AdFormats.Product)
	}
	const setAdFormatInstant = () => {
		setFormat(AdFormats.Instant)
	}
	const setAdFormatVideo = () => {
		setFormat(AdFormats.Video)
	}
	const setAdFormatTrueNative = () => {
		setFormat(AdFormats.TrueNative)
	}

	return (
		<div className="ad-format">
			<Header variation="h2" style={{ paddingBottom: 30 }}>
				Choose the Ad Format For Your Campaign
			</Header>
			<Row>
				<Col md={10} mdOffset={1} lg={8} lgOffset={2}>
					<div className="ad-format__cards">
						<Card
							title="Content Native"
							description="Choose this, if you want to promote content from a blog or a landing page"
							img="/images/contentnative.png"
							setFormat={setAdFormatNative}
							active={adFormat === AdFormats.Content}
						/>
						<Card
							title="Product Native"
							description="Choose this, if you want to promote a product, event, frontpage or a web store"
							img="/images/productnative.png"
							setFormat={setAdFormatProduct}
							active={adFormat === AdFormats.Product}
						/>
						<Card
							title="Instant Article"
							description="Market your content online without building a separate landing page. Your content will be displayed as an overlay on your website."
							img="/images/instantarticle.png"
							setFormat={setAdFormatInstant}
							active={adFormat === AdFormats.Instant}
							beta
						/>
						<Card
							title="Video Native"
							description="Choose this option if you want to promote video content and enhance the experience with a clear headline and body text."
							img="/images/video_native.png"
							setFormat={setAdFormatVideo}
							active={adFormat === AdFormats.Video}
						/>
						{showTrueNative && (
							<Card
								title="True Native"
								description="Create landing pages that match the publisher's site design and feel like native content"
								img="/images/instantarticle.png"
								setFormat={setAdFormatTrueNative}
								active={adFormat === AdFormats.TrueNative}
								beta
							/>
						)}
					</div>
					{adFormat === AdFormats.Instant && (
						<>
							Learn more about the Instant Article format{' '}
							<a href="https://www.readpeak.com/instant-article" target="_blank" rel="noreferrer">
								here.
							</a>
							<InstantArticleScript />
						</>
					)}
					{adFormat !== AdFormats.Instant &&
						adFormat !== AdFormats.Video &&
						adFormat !== AdFormats.TrueNative && (
							<>
								Learn more about the differences between Content and Product Native campaigns{' '}
								<a href="https://get.readpeak.com/product-native/" target="_blank" rel="noreferrer">
									here.
								</a>
							</>
						)}
					{adFormat === AdFormats.Video && (
						<>
							Learn more about how to create great videos{' '}
							<a href="https://get.readpeak.com/video-native/" target="_blank" rel="noreferrer">
								here.
							</a>
						</>
					)}
					{adFormat === AdFormats.TrueNative && (
						<>
							Learn more about True Native campaigns{' '}
							<a href="https://get.readpeak.com/true-native/" target="_blank" rel="noreferrer">
								here.
							</a>
						</>
					)}
				</Col>
			</Row>
		</div>
	)
}

export default AdFormat
